import { ILanguages, IRoutes } from './types'

export const htmlLang: Record<string, string> = {
  uk: 'en-GB'
}

// Routes and Translations.
export const ROUTES: Record<IRoutes, ILanguages> = {
  [IRoutes.CALCULATOR]: {
    es: 'calculadora',
    en: 'calculator',
    fr: 'calculateur',
    uk: 'calculator',
    it: 'calcolatore',
    au: 'calculator',
    us: 'calculator',
    nl: 'calculator',
    de: 'online-kalkulator'
  },
  [IRoutes.HOME]: {
    es: 'inicio',
    en: 'home',
    fr: 'accueil',
    uk: 'home',
    it: 'inizio',
    au: 'home',
    us: 'home',
    nl: 'home',
    de: 'startseite'
  },
  [IRoutes.ABOUT_US]: {
    es: 'sobre-nosotros',
    en: 'about-us',
    fr: 'a-propos-de-nous',
    uk: 'about-us',
    it: 'chi-siamo',
    au: 'about-us',
    us: 'about-us',
    nl: 'over-ons',
    de: 'ueber-uns'
  },
  [IRoutes.LOGIN]: {
    es: 'acceso',
    en: 'login',
    fr: 'login',
    uk: 'login',
    it: 'accesso',
    au: 'login',
    us: 'login',
    nl: 'login',
    de: 'login'
  },
  [IRoutes.SIGNUP]: {
    es: 'inscribirse',
    en: 'signup',
    fr: 'creer-compte-client',
    uk: 'signup',
    it: 'crea-un-account',
    au: 'signup',
    us: 'signup',
    nl: 'account-aanmaken',
    de: 'registrierung'
  },
  [IRoutes.FORGOT_PASSWORD]: {
    es: 'se-te-olvido-tu-contrasena',
    en: 'forgot-password',
    fr: 'reinitialiser-mot-de-passe',
    uk: 'password-reset',
    it: 'password-dimenticata',
    au: 'forgot-password',
    us: 'forgot-password',
    nl: 'wachtwoord-reset',
    de: 'passwordreset'
  },
  [IRoutes.PRIVACY_POLICY]: {
    es: 'politica-de-privacidad',
    en: 'privacy-policy',
    fr: 'politique-de-confidentialite',
    uk: 'privacy-policy',
    it: 'informativa-sulla-privacy',
    au: 'privacy-policy',
    us: 'privacy-policy',
    nl: 'privacybeleid-cookies',
    de: 'datenschutz'
  },
  [IRoutes.CONTACT]: {
    es: 'contacto',
    en: 'contact',
    fr: 'contact',
    uk: 'contact',
    it: 'contattaci',
    au: 'contact',
    us: 'contact',
    nl: 'klantenservice',
    de: 'Kontakt'
  },
  [IRoutes.GLOSSARY]: {
    es: 'glosario',
    en: 'glossary',
    fr: 'glossaire',
    uk: 'glossary',
    it: 'glossario',
    au: 'glossary',
    us: 'glossary',
    nl: 'begrippenlijst',
    de: 'glossar'
  },
  [IRoutes.TUTORIALS]: {
    es: 'tutoriales',
    en: 'tutorials',
    fr: 'tutoriels',
    uk: 'tutorials',
    it: 'tutorial',
    au: 'tutorials',
    us: 'tutorials',
    nl: 'tutorials',
    de: 'tutorials'
  },
  [IRoutes.JOBS]: {
    es: 'empleos',
    en: 'jobs',
    fr: 'jobs',
    uk: 'jobs',
    it: 'carriera',
    au: 'jobs',
    us: 'jobs',
    nl: 'jobs',
    de: 'jobs'
  },
  [IRoutes.FAQ]: {
    es: 'preguntas-mas-frecuentes',
    en: 'customer-service-faq',
    fr: 'faq',
    uk: 'customer-service-faq',
    it: 'domande-frequenti',
    au: 'customer-service-faq',
    us: 'customer-service-faq',
    nl: 'veel-gestelde-vragen',
    de: 'fragen'
  },
  [IRoutes.MATERIALS]: {
    es: 'materiales',
    en: 'materials',
    fr: 'supports',
    uk: 'material-guide',
    it: 'materiali',
    au: 'materials',
    us: 'materials',
    nl: 'papier-en-materialen',
    de: 'materialien'
  },

  [IRoutes.EXPRESS_PRODUCTION]: {
    es: 'produccion-expresa-v2',
    en: 'produccion-expresa-v2',
    fr: 'production-express',
    uk: 'express-production',
    it: 'produzione-espressa',
    au: 'express-production-v2',
    us: 'express-production',
    nl: 'expressproductie',
    de: 'expressproduktion'
  },
  [IRoutes.DELIVERY_SHIPPING]: {
    es: 'gastos-de-envio-y-entrega',
    en: 'delivery-and-shipping-costs',
    fr: 'livraison',
    uk: 'delivery-and-shipping-costs',
    it: 'costi-di-consegna-e-spedizione',
    au: 'delivery-and-shipping-costs',
    us: 'delivery-and-shipping-costs',
    nl: 'productie-en-verzending',
    de: 'produktion-und-versand'
  },
  [IRoutes.FINISHING_TOUCHES]: {
    es: 'acabados-finales',
    en: 'finishing-touches',
    fr: 'finitions',
    uk: 'finishing-touches',
    it: 'finiture',
    au: 'finishing-touches',
    us: 'finishing-options',
    nl: 'afwerkingen',
    de: 'veredelungen'
  },
  [IRoutes.REFERENCE_CUSTOMERS]: {
    es: 'clientes',
    en: 'reference-customers',
    fr: 'nos-references',
    uk: 'our-references',
    it: 'clienti-di-riferimento',
    au: 'reference-customers',
    us: 'reference-customers',
    nl: 'referentieklanten',
    de: 'referenzkunden'
  },
  [IRoutes.CUSTOMERS_STORIES]: {
    es: 'historias-de-clientes',
    en: 'customer-stories',
    fr: 'temoignages',
    uk: 'customer-stories',
    it: 'storie-di-successo',
    au: 'customer-stories',
    us: 'customer-stories',
    nl: 'klantverhalen',
    de: 'kundenstories'
  },
  [IRoutes.NEWS]: {
    es: 'noticias',
    en: 'news',
    fr: 'actualites',
    uk: 'news',
    it: 'novita',
    au: 'news',
    us: 'news',
    nl: 'nieuws',
    de: 'news'
  },
  [IRoutes.PRESS]: {
    es: 'prensa',
    en: 'press',
    fr: 'communiques',
    uk: 'press',
    it: 'comunicati',
    au: 'press',
    us: 'press',
    nl: 'pers',
    de: 'presse'
  },
  [IRoutes.LABEL_GALLERY]: {
    es: 'galeria-de-etiquetas',
    en: 'label-gallery',
    fr: 'galerie-etiquettes',
    uk: 'label-gallery',
    it: 'galleria-immagini',
    au: 'label-gallery',
    us: 'label-gallery',
    nl: 'etiketten-galerij',
    de: 'etikettengalerie'
  },
  [IRoutes.CATEGORIES]: {
    es: 'categorias',
    en: 'categories',
    fr: 'produits',
    uk: 'products',
    it: 'categorie',
    au: 'categories',
    us: 'products',
    nl: 'producten',
    de: 'produkte'
  },
  [IRoutes.PRODUCTS]: {
    es: 'productos',
    en: 'products',
    fr: 'produits',
    uk: 'products',
    it: 'prodotti',
    au: 'products',
    us: 'products',
    nl: 'producten',
    de: 'produkte'
  },
  [IRoutes.PROOFING_SERVICE]: {
    es: 'prueba-de-impresion',
    en: 'proofing-service',
    fr: 'impression-test',
    uk: 'proofing-service',
    it: 'prova-di-stampa',
    au: 'proofing-service',
    us: 'proofing-service',
    nl: 'proef-productie',
    de: 'probedruck'
  },
  [IRoutes.ARTWORK_SERVICES]: {
    es: 'servicios-de-revision',
    en: 'artwork-services',
    fr: 'correction-graphique',
    uk: 'artwork-services',
    it: 'servizio-di-correzione',
    au: 'artwork-services',
    us: 'artwork-services',
    nl: 'drukbestandenservice',
    de: 'druckdatenwerkstatt'
  },
  [IRoutes.PRINT_DATA_DELIVERY]: {
    es: 'entrega-de-archivos-de-impresion',
    en: 'print-data-delivery',
    fr: 'fichiers-graphiques',
    uk: 'print-data-delivery',
    it: 'linee-guida-file-di-stampa',
    au: 'print-data-delivery',
    us: 'artwork-guidelines',
    nl: '/aanleverinstructies',
    de: 'datenanlieferung'
  },
  [IRoutes.SAMPLE_BOOK]: {
    es: 'muestrario',
    en: 'sample-book',
    fr: 'echantillons',
    uk: 'sample-book',
    it: 'campionario',
    au: 'sample-book',
    us: 'sample-book',
    nl: 'gratis-materialenboek',
    de: 'musterbuch'
  },
  [IRoutes.ARTWORK_ASSISTANT]: {
    es: 'crea-tu-archivo',
    en: 'artwork-assistant',
    fr: 'assistant-de-creation-graphique',
    uk: 'artwork-assistant',
    it: 'template-etichette',
    au: 'artwork-assistant',
    us: 'artwork-assistant',
    nl: 'drukbestanden-assistent',
    de: 'druckvorlagenhilfe'
  },
  [IRoutes.DESIGN_SERVICE]: {
    es: 'servicios-de-diseno',
    en: 'design-service',
    fr: 'creation-graphique',
    uk: 'design-service',
    it: 'servizio-di-progettazione-grafica',
    au: 'design-service',
    us: 'design-service',
    nl: 'ontwerpservice',
    de: 'designservice'
  },
  [IRoutes.SIGNUP_SUCCESS]: {
    es: 'activar-cuenta',
    en: 'activate-account',
    fr: 'creation-compte-reussie',
    uk: 'activate-account',
    it: 'attivazione-account',
    au: 'activate-account',
    us: 'activate-account',
    nl: 'succesvol-geregistreerd',
    de: 'konto-erfolgreich-angelegt'
  },
  [IRoutes.TRANSPARENCY_CALCULATOR]: {
    es: 'calculadora-transparency',
    en: 'transparency-calculator',
    fr: 'transparency',
    uk: 'transparency',
    it: 'calcolatore-transparency',
    au: 'transparency-calculator',
    us: 'transparency-calculator',
    nl: 'transparency',
    de: 'transparency'
  },
  [IRoutes.CART]: {
    es: 'cesta',
    en: 'cart',
    fr: 'panier',
    uk: 'basket',
    it: 'carrello',
    au: 'cart',
    us: 'cart',
    nl: 'winkelwagen',
    de: 'warenkorb'
  },
  [IRoutes.LEGAL_WARNING]: {
    es: 'aviso-legal',
    en: 'legal-warning',
    fr: 'mentions-legales',
    uk: 'imprint',
    it: 'informazione-legale',
    au: 'legal-warning',
    us: 'legal-warning',
    nl: 'colofon',
    de: 'impressum'
  },
  [IRoutes.CONDITIONS_OF_SALE]: {
    es: 'condiciones-generales-de-venta',
    en: 'general-conditions-of-sale',
    fr: 'conditions-generales-de-vente',
    uk: 'general-conditions-of-sale',
    it: 'condizioni-generali-di-vendita',
    au: 'general-conditions-of-sale',
    us: 'general-conditions-of-sale',
    nl: 'algemene-voorwaarden',
    de: 'agb'
  },
  [IRoutes.LINKING_AGREEMENT]: {
    es: 'linking-agreement',
    en: 'linking-agreement',
    fr: 'linking-agreement',
    uk: 'linking-agreement',
    it: 'linking-agreement',
    au: 'linking-agreement',
    us: 'linking-agreement',
    nl: 'linking-agreement',
    de: 'linking-agreement'
  },
  [IRoutes.TERMS_CONDITIONS_OF_ORDER]: {
    es: 'terms-conditions-of-order',
    en: 'terms-conditions-of-order',
    fr: 'terms-conditions-of-order',
    uk: 'terms-conditions-of-order',
    it: 'terms-conditions-of-order',
    au: 'terms-conditions-of-order',
    us: 'terms-conditions-of-order',
    nl: 'terms-conditions-of-order',
    de: 'terms-conditions-of-order'
  },
  [IRoutes.TERMS_CONDITIONS_OF_USE]: {
    es: 'terms-conditions-of-use',
    en: 'terms-conditions-of-use',
    fr: 'terms-conditions-of-use',
    uk: 'terms-conditions-of-use',
    it: 'terms-conditions-of-use',
    au: 'terms-conditions-of-use',
    us: 'terms-conditions-of-use',
    nl: 'terms-conditions-of-use',
    de: 'terms-conditions-of-use'
  },
  [IRoutes.PAGE_NOT_FOUND]: {
    es: 'pagina-no-encontrada',
    en: 'page-not-found',
    fr: 'page-introuvable',
    uk: 'page-not-found',
    it: 'pagina-non-trovata',
    au: 'page-not-found',
    us: 'page-not-found',
    nl: 'pagina-niet-gevonden',
    de: 'seite-nicht-gefunden'
  },
  [IRoutes.UPLOAD_FILES]: {
    es: 'upload-files',
    en: 'upload-files',
    fr: 'upload-files',
    uk: 'upload-files',
    it: 'upload-files',
    au: 'upload-files',
    us: 'upload-files',
    nl: 'upload-files',
    de: 'druckdaten-hochladen'
  },
  [IRoutes.MY_ACCOUNT]: {
    es: 'mi-cuenta',
    en: 'my-account',
    fr: 'mon-compte',
    uk: 'my-account',
    it: 'il-mio-account',
    au: 'my-account',
    us: 'my-account',
    nl: 'mijn-account',
    de: 'mein-konto'
  },
  [IRoutes.MANAGE_CREDENTIALS]: {
    es: 'administrar-credenciales',
    en: 'manage-credentials',
    fr: 'gerer-mon-compte',
    uk: 'manage-credentials',
    it: 'administrar-credenciales',
    au: 'administrar-credenciales',
    us: 'administrar-credenciales',
    nl: 'beheer-inloggegevens',
    de: 'manage-credentials'
  },
  [IRoutes.PROOF_ORDER]: {
    es: 'prueba-de-pedido',
    en: 'proof-order',
    fr: 'formulaire-impression-test',
    uk: 'proof-order',
    it: 'ordinare-prova-di-stampa',
    au: 'proof-order',
    us: 'proof-order',
    nl: '/proefdruk-form',
    de: 'probedruck-formular'
  },
  [IRoutes.CUSTOMER_REGISTERED]: {
    es: 'bienvenido',
    en: 'welcome',
    fr: 'bienvenu',
    uk: 'welcome',
    it: 'benvenuto',
    au: 'welcome',
    us: 'welcome',
    nl: 'welkom',
    de: 'willkommen'
  },
  [IRoutes.MY_ORDERS]: {
    es: 'mi-cuenta/ordenes',
    en: 'my-account/orders',
    fr: 'mon-compte/mes-commandes',
    uk: 'my-account/orders',
    it: 'il-mio-account/ordini',
    au: 'my-account/orders',
    us: 'my-account/orders',
    nl: 'mijn-account/mijn-orders',
    de: 'mein-konto/bestellungen'
  },
  [IRoutes.MY_INVOICES]: {
    es: 'mi-cuenta/facturas',
    en: 'my-account/invoices',
    fr: 'mon-compte/factures',
    it: 'il-mio-account/fatture',
    au: 'my-account/invoices',
    uk: 'my-account/invoices',
    us: 'my-account/invoices',
    nl: 'mijn-account/facturen',
    de: 'mein-konto/rechnungen'
  },
  [IRoutes.ARTWORK_SERVICES_REVIEW_INFO]: {
    es: 'artwork-service-revision',
    en: 'artwork-service-revision',
    fr: 'revision-correction-graphique',
    uk: 'artwork-service-review',
    it: 'recensione-del-servizio-di-grafica',
    au: 'artwork-service-revision',
    us: 'artwork-service-revision',
    nl: 'artwork-service-revision', // No info,
    de: 'pre-print-artwork'
  },
  [IRoutes.ERROR_PAGE]: {
    es: 'pagina-de-errores',
    en: 'error-page',
    fr: 'page-erreur',
    uk: 'error-page',
    it: 'pagina-di-errore',
    au: 'error-page',
    us: 'error-page',
    nl: 'foutpagina',
    de: 'fehlerseite'
  },
  [IRoutes.SUSTAINABILITY]: {
    es: 'etiquetas-sostenibles',
    en: 'sustainability',
    fr: 'etiquettes-durables',
    uk: 'sustainable-labels',
    it: 'etichette-sostenibili',
    au: 'sustainability',
    us: 'sustainability',
    nl: 'milieuvriendelijke-etiketten',
    de: 'nachhaltige-etiketten'
  },
  [IRoutes.ORDER_ARTWORK_SERVICE]: {
    es: 'encargar-servicios-de-revision',
    en: 'order-artwork-service',
    fr: 'formulaire-correction-graphique',
    uk: 'order-artwork-service',
    it: 'ordine-servizio-di-correzione',
    au: 'order-artwork-service',
    us: 'order-artwork-service',
    nl: 'bestandscontrole-service-form',
    de: 'druckdatenwerkstatt-formular'
  },
  [IRoutes.SAMPLE_SEARCH]: {
    es: 'muestra-de-busqueda',
    en: 'sample-search',
    fr: 'recherche-echantillons',
    uk: 'sample-search',
    it: 'ricerca-campioni',
    au: 'sample-search',
    us: 'sample-search',
    nl: 'sample-zoeken',
    de: 'mustersuche'
  },
  [IRoutes.LABEL_LIBRARY]: {
    es: 'biblioteca-de-etiquetas',
    en: 'label-library',
    fr: 'bibliotheque-etiquettes',
    it: 'libreria-etichette',
    au: 'label-library',
    uk: 'label-library',
    us: 'label-library',
    nl: 'labelbibliotheek',
    de: 'etikettenbibliothek'
  },
  [IRoutes.PERSONAL_INFOS]: {
    es: 'mi-cuenta/informacion-personal',
    en: 'my-account/personal-infos',
    fr: 'mon-compte/personal-infos',
    uk: 'my-account/personal-infos',
    it: 'il-mio-account/informazioni-personali',
    au: 'mi-cuenta/informacion-personal',
    us: 'mi-cuenta/informacion-personal',
    nl: 'mijn-account/persoonlijke-gegevens',
    de: 'mein-konto/persoenliche-infos'
  },
  [IRoutes.CALCULATOR_HELP]: {
    es: 'calculator-help',
    en: 'calculator-help',
    fr: 'calculator-help',
    uk: 'calculator-help',
    it: 'calculator-help',
    au: 'calculator-help',
    us: 'calculator-help',
    nl: 'calculator-help',
    de: 'calculator-help'
  },
  [IRoutes.NEWSLETTER]: {
    es: 'boletin',
    en: 'newsletter',
    fr: 'newsletter',
    uk: 'newsletter',
    it: 'bollettino',
    au: 'newsletter',
    us: 'newsletter',
    nl: 'nieuwsbrief',
    de: 'newsletter'
  },
  [IRoutes.THANK_YOU]: {
    es: 'gracias-por-suscribirte',
    en: 'thank-you',
    fr: 'abonnement-newsletter-reussi',
    uk: 'newsletter-subscription-successful',
    it: 'grazie-per-liscrizione',
    au: 'thank-you',
    us: 'thank-you',
    nl: 'nieuwsbrief-abonnement',
    de: 'newsletter-anmeldung-erfolgreich'
  },
  [IRoutes.THANK_YOU_ORDER]: {
    es: 'gracias-por-tu-pedido',
    en: 'thank-you-for-your-order',
    fr: 'merci-pour-votre-commande',
    uk: 'order-thank-you',
    it: 'grazie-per-il-tuo-ordine',
    au: 'thank-you-for-your-order',
    us: 'thank-you-for-your-order',
    nl: 'dank-voor-uw-bestelling',
    de: 'danke-fuer-die-bestellung'
  },
  [IRoutes.REQUEST_THANK_YOU]: {
    es: 'gracias-por-tu-solicitud',
    en: 'thank-you-for-your-request',
    fr: 'merci-book-echantillons',
    uk: 'sample-book-thank-you',
    it: 'grazie-per-la-tua-richiesta',
    au: 'thank-you-for-your-request',
    us: 'thank-you-for-your-request',
    nl: 'dank-materialenboek',
    de: 'danke-musterbuch'
  },
  [IRoutes.SURVEY_THANK_YOU]: {
    es: 'gracias-por-participar-en-nuestra-encuesta',
    en: 'thank-you-for-participating-in-survey',
    fr: 'participation-enquete',
    uk: 'survey-taken',
    it: 'sondaggio-completato',
    au: 'thank-you-for-participating-in-survey',
    us: 'thank-you-for-participating-in-survey',
    nl: 'enquete-ingevuld',
    de: 'umfrage-abgeschlossen'
  },
  [IRoutes.HEADER]: {
    es: 'header',
    en: 'header',
    fr: 'header',
    uk: 'header',
    it: 'header',
    au: 'header',
    us: 'header',
    nl: 'header',
    de: 'header'
  },
  [IRoutes.FOOTER]: {
    es: 'footer',
    en: 'footer',
    fr: 'footer',
    uk: 'footer',
    it: 'footer',
    au: 'footer',
    us: 'footer',
    nl: 'footer',
    de: 'footer'
  },
  [IRoutes.BLOGS_LANDING_PAGE]: {
    es: 'blogs-landing-page',
    en: 'blogs-landing-page',
    fr: 'blogs-landing-page',
    uk: 'blogs-landing-page',
    it: 'blogs-landing-page',
    au: 'blogs-landing-page',
    us: 'blogs-landing-page',
    nl: 'blogs-landing-page',
    de: 'blogs-landing-page'
  },
  [IRoutes.BLOGS]: {
    es: 'blog',
    en: 'blog',
    fr: 'blog',
    uk: 'blog',
    it: 'blog',
    au: 'blog',
    us: 'blog',
    nl: 'blog',
    de: 'blog'
  },
  [IRoutes.CUSTOM_PAGES]: {
    es: 'pagina',
    en: 'page',
    fr: 'page',
    uk: 'page',
    it: 'pagina',
    au: 'page',
    us: 'page',
    nl: 'page',
    de: 'seite'
  },
  [IRoutes.REORDER]: {
    es: 'my-account/label-library/reorder',
    en: 'my-account/label-library/reorder',
    fr: 'mon-compte/bibliotheque-etiquettes/reorder',
    uk: 'my-account/label-library/reorder',
    it: 'il-mio-account/libreria-delle-etichette/reorder',
    au: 'my-account/label-library/reorder',
    us: 'my-account/label-library/reorder',
    nl: 'mijn-account/labelbibliotheek/reorder',
    de: 'mein-konto/etikettenbibliothek/reorder'
  },
  [IRoutes.LABEL_LIBRARY_MY_ORDER_FILES]: {
    es: 'mi-cuenta/biblioteca-de-etiquetas/myorder-files',
    en: 'my-account/label-library/myorder-files',
    fr: 'mon-compte/bibliotheque-etiquettes/myorder-files',
    it: 'il-mio-account/libreria-etichette/myorder-files',
    uk: 'my-account/label-library/myorder-files',
    au: 'my-account/label-library/myorder-files',
    us: 'my-account/label-library/myorder-files',
    nl: 'mijn-account/labelbibliotheek/myorder-files',
    de: 'mein-konto/etikettenbibliothek/myorder-files'
  },
  [IRoutes.CUSTOM_FILES]: {
    es: 'mi-cuenta/biblioteca-de-etiquetas/custom-files',
    en: 'my-account/label-library/custom-files',
    fr: 'mon-compte/bibliotheque-etiquettes/custom-files',
    uk: 'my-account/label-library/custom-files',
    it: 'il-mio-account/libreria-etichette/custom-files',
    au: 'my-account/label-library/custom-files',
    us: 'my-account/label-library/custom-files',
    nl: 'mijn-account/labelbibliotheek/custom-files',
    de: 'mein-konto/etikettenbibliothek/custom-files'
  },
  [IRoutes.SUCCESS_STORIES]: {
    es: 'success-stories',
    en: 'success-stories',
    fr: 'success-stories',
    uk: 'success-stories',
    it: 'success-stories',
    au: 'success-stories',
    us: 'success-stories',
    nl: 'success-stories',
    de: 'success-stories'
  },
  [IRoutes.PRINT_FILE_ERRORS]: {
    es: 'print-file-error',
    en: 'print-file-error',
    fr: 'print-file-error',
    uk: 'print-file-error',
    it: 'errori-comuni-nei-fi',
    au: 'print-file-error',
    us: 'print-file-error',
    nl: 'print-file-error',
    de: 'print-file-error'
  },
  [IRoutes.PRINT_FILE_ERRORS_FULL]: {
    es: 'print-file-error',
    en: 'print-file-error',
    fr: 'fichiers-non-conformes',
    uk: 'data-errors-in-your-print-files',
    it: 'errori-comuni-nei-file-di-stampa',
    au: 'print-file-error',
    us: 'print-file-error',
    nl: 'errors-in-druckbestanden',
    de: 'datenfehler'
  },
  [IRoutes.TUTORIAL]: {
    es: 'tutoriales',
    en: 'tutorials',
    it: 'tutorial',
    au: 'tutorials',
    us: 'tutorial',
    uk: 'tutorial',
    fr: 'tutorial',
    nl: 'tutorial',
    de: 'tutorials'
  },
  [IRoutes.TUTORIAL_CMS]: {
    es: 'tutorial',
    en: 'tutorials',
    fr: 'tutorial',
    uk: 'tutorial',
    it: 'tutorial',
    au: 'tutorial',
    us: 'tutorial',
    nl: 'tutorial',
    de: 'tutorial'
  }
}

const createRouteList = (routes: Object) => {
  const list = {}

  Object.values(routes).forEach((item) => {
    list[`/${item.es}`] = `/${item.en}`
  })
  return list
}

export const routeList = createRouteList(ROUTES)

export const ROUTER_PATH: Record<IRoutes, ILanguages> = {
  [IRoutes.CALCULATOR]: {
    es: '/calculadora',
    en: '/calculator',
    fr: '/calculateur',
    uk: '/calculator',
    it: '/calcolatore',
    au: '/calculator',
    us: '/calculator',
    nl: '/calculator',
    de: '/online-kalkulator'
  },
  [IRoutes.HOME]: {
    es: '/',
    en: '/',
    fr: '/',
    uk: '/',
    it: '/',
    au: '/',
    us: '/',
    nl: '/',
    de: '/'
  },
  [IRoutes.ABOUT_US]: {
    es: '/sobre-nosotros',
    en: '/about-us',
    fr: '/a-propos-de-nous',
    uk: '/about-us',
    it: '/chi-siamo',
    au: '/about-us',
    us: '/about-us',
    nl: '/over-ons',
    de: '/ueber-uns'
  },
  [IRoutes.LOGIN]: {
    es: '/acceso',
    en: '/login',
    fr: '/login',
    uk: '/login',
    it: '/accesso',
    au: '/login',
    us: '/login',
    nl: '/login',
    de: '/login'
  },
  [IRoutes.SIGNUP]: {
    es: '/inscribirse',
    en: '/signup',
    fr: '/creer-compte-client',
    uk: '/signup',
    it: '/crea-un-account',
    au: '/signup',
    us: '/signup',
    nl: '/account-aanmaken',
    de: '/registrierung'
  },
  [IRoutes.FORGOT_PASSWORD]: {
    es: '/se-te-olvido-tu-contrasena',
    en: '/forgot-password',
    fr: '/reinitialiser-mot-de-passe',
    uk: '/passwordreset',
    it: '/password-dimenticata',
    au: '/forgot-password',
    us: '/forgot-password',
    nl: '/wachtwoord-reset',
    de: '/passwordreset'
  },
  [IRoutes.PRIVACY_POLICY]: {
    es: '/politica-de-privacidad',
    en: '/privacy-policy',
    fr: '/politique-de-confidentialite',
    uk: '/privacy-policy',
    it: '/informativa-sulla-privacy',
    au: '/privacy-policy',
    us: '/privacy-policy',
    nl: '/privacybeleid-cookies',
    de: '/datenschutz'
  },
  [IRoutes.CONTACT]: {
    es: '/contacto',
    en: '/contact',
    fr: '/contact',
    uk: '/contact',
    it: '/contattaci',
    au: '/contact',
    us: '/contact',
    nl: '/klantenservice',
    de: '/Kontakt'
  },
  [IRoutes.GLOSSARY]: {
    es: '/glosario',
    en: '/glossary',
    fr: '/glossaire',
    uk: '/glossary',
    it: '/glossario',
    au: '/glossary',
    us: '/glossary',
    nl: '/begrippenlijst',
    de: '/glossar'
  },
  [IRoutes.TUTORIALS]: {
    es: '/tutoriales',
    en: '/tutorials',
    fr: '/tutoriels',
    uk: '/tutorials',
    it: '/tutorial',
    au: '/tutorials',
    us: '/tutorials',
    nl: '/tutorials',
    de: '/tutorials'
  },
  [IRoutes.JOBS]: {
    es: '/empleos',
    en: '/jobs',
    fr: '/jobs',
    uk: '/jobs',
    it: '/carriera',
    au: '/jobs',
    us: '/jobs',
    nl: '/jobs',
    de: '/jobs'
  },
  [IRoutes.FAQ]: {
    es: '/preguntas-mas-frecuentes',
    en: '/customer-service-faq',
    fr: '/faq',
    uk: '/customer-service-faq',
    it: '/domande-frequenti',
    au: '/customer-service-faq',
    us: '/customer-service-faq',
    nl: '/veel-gestelde-vragen',
    de: '/fragen'
  },
  [IRoutes.MATERIALS]: {
    es: '/materiales',
    en: '/materials',
    fr: '/supports',
    uk: '/material-guide',
    it: '/materiali',
    au: '/materials',
    us: '/materials',
    nl: '/papier-en-materialen',
    de: '/materialien'
  },
  [IRoutes.EXPRESS_PRODUCTION]: {
    es: '/produccion-expresa',
    en: '/express-production',
    fr: '/production-express',
    uk: '/express-production',
    it: '/produzione-espressa',
    au: '/express-production',
    us: '/express-production',
    nl: '/expressproductie',
    de: '/expressproduktion'
  },
  [IRoutes.DELIVERY_SHIPPING]: {
    es: '/gastos-de-envio-y-entrega',
    en: '/delivery-and-shipping-costs',
    fr: '/livraison',
    uk: '/delivery-and-shipping-costs',
    it: '/costi-di-consegna-e-spedizione',
    au: '/delivery-and-shipping-costs',
    us: '/delivery-and-shipping-costs',
    nl: '/productie-en-verzending',
    de: '/produktion-und-versand'
  },
  [IRoutes.FINISHING_TOUCHES]: {
    es: '/acabados-finales',
    en: '/finishing-touches',
    fr: '/finitions',
    uk: '/finishing-touches',
    it: '/finiture',
    au: '/finishing-touches',
    us: '/finishing-options',
    nl: '/afwerkingen',
    de: '/veredelungen'
  },
  [IRoutes.REFERENCE_CUSTOMERS]: {
    es: '/clientes',
    en: '/reference-customers',
    fr: '/nos-references',
    uk: '/our-references',
    it: '/clienti-di-riferimento',
    au: '/reference-customers',
    us: '/reference-customers',
    nl: '/referentieklanten',
    de: '/referenzkunden'
  },
  [IRoutes.CUSTOMERS_STORIES]: {
    es: '/historias-de-clientes',
    en: '/customer-stories',
    fr: '/temoignages',
    uk: '/customer-stories',
    it: '/storie-di-successo',
    au: '/customer-stories',
    us: '/customer-stories',
    nl: '/klantverhalen',
    de: '/kundenstories'
  },
  [IRoutes.NEWS]: {
    es: '/noticias',
    en: '/news',
    fr: '/actualites',
    uk: '/news',
    it: '/novitÃ ',
    au: '/news',
    us: '/news',
    nl: '/nieuws',
    de: '/news'
  },
  [IRoutes.PRESS]: {
    es: '/prensa',
    en: '/press',
    fr: '/communiques',
    uk: '/press',
    it: '/comunicati',
    au: '/press',
    us: '/press',
    nl: '/pers',
    de: '/presse'
  },
  [IRoutes.LABEL_GALLERY]: {
    es: '/galeria-de-etiquetas',
    en: '/label-gallery',
    fr: '/galerie-etiquettes',
    uk: '/label-gallery',
    it: '/galleria-immagini',
    au: '/label-gallery',
    us: '/label-gallery',
    nl: '/etiketten-galerij',
    de: '/etikettengalerie'
  },
  [IRoutes.CATEGORIES]: {
    es: '/categorias',
    en: '/categories',
    fr: '/secteur',
    uk: '/products',
    it: '/categorie',
    au: '/categories',
    us: '/products',
    nl: '/producten',
    de: '/produkte'
  },
  [IRoutes.PRODUCTS]: {
    es: '/productos',
    en: '/products',
    fr: '/produits',
    uk: '/products',
    it: '/prodotti',
    au: '/products',
    us: '/products',
    nl: '/producten',
    de: '/produkte'
  },
  [IRoutes.PROOFING_SERVICE]: {
    es: '/prueba-de-impresion',
    en: '/proofing-service',
    fr: '/impression-test',
    uk: '/proofing-service',
    it: '/prova-di-stampa',
    au: '/proofing-service',
    us: '/proofing-service',
    nl: '/proef-productie',
    de: '/probedruck'
  },
  [IRoutes.ARTWORK_SERVICES]: {
    es: '/servicios-de-revision',
    en: '/artwork-services',
    fr: '/correction-graphique',
    uk: '/artwork-services',
    it: '/servizio-di-correzione',
    au: '/artwork-services',
    us: '/artwork-services',
    nl: '/drukbestandenservice',
    de: '/druckdatenwerkstatt'
  },
  [IRoutes.PRINT_DATA_DELIVERY]: {
    es: '/entrega-de-archivos-de-impresion',
    en: '/print-data-delivery',
    fr: '/fichiers-graphiques',
    uk: '/print-data-delivery',
    it: '/linee-guida-file-di-stampa',
    au: '/print-data-delivery',
    us: '/artwork-guidelines',
    nl: '/aanleverinstructies',
    de: '/datenanlieferung'
  },
  [IRoutes.SAMPLE_BOOK]: {
    es: '/muestrario',
    en: '/sample-book',
    fr: '/echantillons',
    uk: '/sample-book',
    it: '/campionario',
    au: '/sample-book',
    us: '/sample-book',
    nl: '/gratis-materialenboek',
    de: '/musterbuch'
  },
  [IRoutes.ARTWORK_ASSISTANT]: {
    es: '/crea-tu-archivo',
    en: '/artwork-assistant',
    fr: '/assistant-de-creation-graphique',
    uk: '/artwork-assistant',
    it: '/assistente-grafico',
    au: '/artwork-assistant',
    us: '/artwork-assistant',
    nl: '/drukbestanden-assistent',
    de: '/druckvorlagenhilfe'
  },
  [IRoutes.DESIGN_SERVICE]: {
    es: '/servicios-de-diseno',
    en: '/design-service',
    fr: '/creation-graphique',
    uk: '/design-service',
    it: '/servizio-di-progettazione-grafica',
    au: '/design-service',
    us: '/design-service',
    nl: '/ontwerpservice',
    de: '/designservice'
  },
  [IRoutes.SIGNUP_SUCCESS]: {
    es: '/activar-cuenta',
    en: '/activate-account',
    fr: '/creation-compte-reussie',
    uk: '/activate-account',
    it: '/attivazione-account',
    au: '/activate-account',
    us: '/activate-account',
    nl: '/succesvol-geregistreerd',
    de: '/konto-erfolgreich-angelegt'
  },
  [IRoutes.TRANSPARENCY_CALCULATOR]: {
    es: '/calculadora-transparency',
    en: '/transparency-calculator',
    fr: '/transparency',
    uk: '/transparency-calculator',
    it: '/calcolatore-transparency',
    au: '/transparency-calculator',
    us: '/transparency-calculator',
    nl: '/transparency',
    de: '/transparency'
  },
  [IRoutes.CART]: {
    es: '/cesta',
    en: '/cart',
    fr: '/panier',
    uk: '/basket',
    it: '/carrello',
    au: '/cart',
    us: '/cart',
    nl: '/winkelwagen',
    de: '/warenkorb'
  },
  [IRoutes.LEGAL_WARNING]: {
    es: '/aviso-legal',
    en: '/legal-warning',
    fr: '/mentions-legales',
    uk: '/imprint',
    it: '/informazione-legale',
    au: '/legal-warning',
    us: '/legal-warning',
    nl: '/colofon',
    de: '/impressum'
  },
  [IRoutes.CONDITIONS_OF_SALE]: {
    es: '/condiciones-generales-de-venta',
    en: '/general-conditions-of-sale',
    fr: '/conditions-generales-de-vente',
    uk: '/terms-conditions',
    it: '/condizioni-generali-di-vendita',
    au: '/general-conditions-of-sale',
    us: '/general-conditions-of-sale',
    nl: '/algemene-voorwaarden',
    de: '/agb'
  },
  [IRoutes.LINKING_AGREEMENT]: {
    es: '/linking-agreement',
    en: '/linking-agreement',
    fr: '/linking-agreement',
    uk: '/linking-agreement',
    it: '/linking-agreement',
    au: '/linking-agreement',
    us: '/linking-agreement',
    nl: '/linking-agreement',
    de: '/linking-agreement'
  },
  [IRoutes.TERMS_CONDITIONS_OF_ORDER]: {
    es: '/terms-conditions-of-order',
    en: '/terms-conditions-of-order',
    fr: '/terms-conditions-of-order',
    uk: '/terms-conditions-of-order',
    it: '/terms-conditions-of-order',
    au: '/terms-conditions-of-order',
    us: '/terms-conditions-of-order',
    nl: '/terms-conditions-of-order',
    de: '/terms-conditions-of-order'
  },
  [IRoutes.TERMS_CONDITIONS_OF_USE]: {
    es: '/terms-conditions-of-use',
    en: '/terms-conditions-of-use',
    fr: '/terms-conditions-of-use',
    uk: '/terms-conditions-of-use',
    it: '/terms-conditions-of-use',
    au: '/terms-conditions-of-use',
    us: '/terms-conditions-of-use',
    nl: '/terms-conditions-of-use',
    de: '/terms-conditions-of-use'
  },
  [IRoutes.PAGE_NOT_FOUND]: {
    es: '/pagina-no-encontrada',
    en: '/page-not-found',
    fr: '/page-introuvable',
    uk: '/page-not-found',
    it: '/pagina-non-trovata',
    au: '/page-not-found',
    us: '/page-not-found',
    nl: '/pagina-niet-gevonden',
    de: '/seite-nicht-gefunden'
  },
  [IRoutes.UPLOAD_FILES]: {
    es: '/upload-files',
    en: '/upload-files',
    fr: '/upload-files',
    uk: '/upload-files',
    it: '/upload-files',
    au: '/upload-files',
    us: '/upload-files',
    nl: '/upload-files',
    de: '/druckdaten-hochladen'
  },
  [IRoutes.MY_ACCOUNT]: {
    es: '/mi-cuenta',
    en: '/my-account',
    fr: '/mon-compte',
    uk: '/my-account',
    it: '/il-mio-account',
    au: '/my-account',
    us: '/my-account',
    nl: '/mijn-account',
    de: '/mein-konto'
  },
  [IRoutes.MY_ORDERS]: {
    es: '/mi-cuenta/ordenes',
    en: '/my-account/orders',
    fr: '/mon-compte/mes-commandes',
    uk: '/my-account/orders',
    it: '/il-mio-account/ordini/',
    au: '/my-account/orders',
    us: '/my-account/orders',
    nl: '/mijn-account/mijn-orders',
    de: '/mein-konto/bestellungen'
  },
  [IRoutes.MY_INVOICES]: {
    es: 'mi-cuenta/facturas',
    en: 'my-account/invoices',
    fr: 'mon-compte/factures',
    uk: 'my-account/invoices',
    it: 'il-mio-account/fatture',
    au: 'my-account/invoices',
    us: 'my-account/invoices',
    nl: 'mijn-account/facturen',
    de: 'mein-konto/rechnungen'
  },
  [IRoutes.MANAGE_CREDENTIALS]: {
    es: 'administrar-credenciales',
    en: 'manage-credentials',
    fr: 'gerer-mon-compte',
    uk: 'manage-credentials',
    it: 'administrar-credenciales',
    au: 'manage-credentials',
    us: 'manage-credentials',
    nl: 'beheer-inloggegevens',
    de: 'manage-credentials'
  },
  [IRoutes.PROOF_ORDER]: {
    es: '/prueba-de-pedido',
    en: '/proof-order',
    fr: '/formulaire-impression-test',
    uk: '/proof-order',
    it: '/ordinare-prova-di-stampa',
    au: '/proof-order',
    us: '/proof-order',
    nl: '/proefdruk-form',
    de: '/probedruck-formular'
  },
  [IRoutes.CUSTOMER_REGISTERED]: {
    es: '/bienvenido',
    en: '/welcome',
    fr: '/bienvenu',
    uk: '/welcome',
    it: '/benvenuto',
    au: '/welcome',
    us: '/welcome',
    nl: '/welkom',
    de: '/willkommen'
  },
  [IRoutes.ARTWORK_SERVICES_REVIEW_INFO]: {
    es: '/artwork-service-revision',
    en: '/artwork-service-revision',
    fr: '/revision-correction-graphique',
    uk: '/artwork-service-review',
    it: '/recensione-del-servizio-di-grafica',
    au: '/artwork-service-revision',
    us: '/artwork-service-revision',
    nl: '/artwork-service-revision',
    de: '/pre-print-artwork'
  },
  [IRoutes.ERROR_PAGE]: {
    es: '/pagina-de-errores',
    en: '/error-page',
    fr: '/page-erreur',
    uk: '/error-page',
    it: '/pagina-di-errore',
    au: '/error-page',
    us: '/error-page',
    nl: '/foutpagina',
    de: '/fehlerseite'
  },
  [IRoutes.SUSTAINABILITY]: {
    es: '/etiquetas-sostenibles',
    en: '/sustainability',
    fr: '/etiquettes-durables',
    uk: '/sustainable-labels',
    it: '/etichette-sostenibili',
    au: '/sustainability',
    us: '/sustainability',
    nl: '/milieuvriendelijke-etiketten',
    de: '/nachhaltige-etiketten'
  },
  [IRoutes.ORDER_ARTWORK_SERVICE]: {
    es: '/encargar-servicios-de-revision',
    en: '/order-artwork-service',
    fr: '/formulaire-correction-graphique',
    uk: '/order-artwork-service',
    it: '/ordine-servizio-di-correzione',
    au: '/order-artwork-service',
    us: '/order-artwork-service',
    nl: '/bestandscontrole-service-form',
    de: '/druckdatenwerkstatt-formular'
  },
  [IRoutes.SAMPLE_SEARCH]: {
    es: '/muestra-de-busqueda',
    en: '/sample-search',
    fr: '/recherche-echantillons',
    uk: '/sample-search',
    it: '/ricerca-campioni',
    au: '/sample-search',
    us: '/sample-search',
    nl: '/sample-zoeken',
    de: '/mustersuche'
  },
  [IRoutes.LABEL_LIBRARY]: {
    es: '/biblioteca-de-etiquetas',
    en: '/label-library',
    fr: '/bibliotheque-etiquettes',
    uk: '/label-library',
    it: '/libreria-etichette',
    au: '/label-library',
    us: '/label-library',
    nl: '/labelbibliotheek',
    de: '/etikettenbibliothek'
  },
  [IRoutes.LABEL_LIBRARY_MY_ORDER_FILES]: {
    es: '/mi-cuenta/biblioteca-de-etiquetas/myorder-files',
    en: '/my-account/label-library/myorder-files',
    fr: '/mon-compte/bibliotheque-etiquettes/myorder-files',
    uk: '/my-account/label-library/myorder-files',
    it: '/il-mio-account/libreria-etichette/myorder-files',
    au: '/my-account/label-library/myorder-files',
    us: '/my-account/label-library/myorder-files',
    nl: '/mijn-account/labelbibliotheek/myorder-files',
    de: '/mein-konto/etikettenbibliothek/myorder-files'
  },
  [IRoutes.PERSONAL_INFOS]: {
    es: '/mi-cuenta/informacion-personal',
    en: '/my-account/personal-infos',
    fr: '/mon-compte/personal-infos',
    uk: '/my-account/personal-infos',
    it: '/il-mio-account/informazioni-personali',
    au: '/my-account/personal-infos',
    us: '/my-account/personal-infos',
    nl: '/mijn-account/persoonlijke-gegevens',
    de: '/mein-konto/persoenliche-infos'
  },
  [IRoutes.CALCULATOR_HELP]: {
    es: '/calculator-help',
    en: '/calculator-help',
    fr: '/calculator-help',
    uk: '/calculator-help',
    it: '/calculator-help',
    au: '/calculator-help',
    us: '/calculator-help',
    nl: '/calculator-help',
    de: '/calculator-help'
  },
  [IRoutes.NEWSLETTER]: {
    es: '/boletin',
    en: '/newsletter',
    fr: '/actualites',
    uk: '/newsletter',
    it: '/bollettino',
    au: '/newsletter',
    us: '/newsletter',
    nl: '/nieuwsbrief',
    de: '/newsletter'
  },
  [IRoutes.THANK_YOU]: {
    es: '/gracias-por-suscribirte',
    en: '/thank-you',
    fr: '/abonnement-newsletter-reussi',
    uk: '/newsletter-subscription-successful',
    it: '/grazie-per-liscrizione',
    au: '/thank-you',
    us: '/thank-you',
    nl: '/thank-you',
    de: '/newsletter-anmeldung-erfolgreich'
  },
  [IRoutes.THANK_YOU_ORDER]: {
    es: '/gracias-por-tu-pedido',
    en: '/thank-you-for-your-order',
    fr: '/merci-pour-votre-commande',
    uk: '/order-thank-you',
    it: '/grazie-per-il-tuo-ordine',
    au: '/thank-you-for-your-order',
    us: '/thank-you-for-your-order',
    nl: '/dank-voor-uw-bestelling',
    de: '/danke-fuer-die-bestellung'
  },
  [IRoutes.REQUEST_THANK_YOU]: {
    es: '/gracias-por-tu-solicitud',
    en: '/thank-you-for-your-request',
    fr: '/merci-book-echantillons',
    uk: '/thank-you-for-your-request',
    it: '/grazie-per-la-tua-richiesta',
    au: '/thank-you-for-your-request',
    us: '/thank-you-for-your-request',
    nl: '/dank-materialenboek',
    de: '/danke-musterbuch'
  },
  [IRoutes.SURVEY_THANK_YOU]: {
    es: '/gracias-por-participar-en-nuestra-encuesta',
    en: '/thank-you-for-participating-in-survey',
    fr: '/participation-enquete',
    uk: '/thank-you-for-participating-in-survey',
    it: '/sondaggio-completato',
    au: '/thank-you-for-participating-in-survey',
    us: '/thank-you-for-participating-in-survey',
    nl: '/enquete-ingevuld',
    de: '/umfrage-abgeschlossen'
  },
  [IRoutes.HEADER]: {
    es: '/header',
    en: '/header',
    fr: '/header',
    uk: '/header',
    it: '/intestazione',
    au: '/calculator-help',
    us: '/calculator-help',
    nl: '/header',
    de: '/header'
  },
  [IRoutes.FOOTER]: {
    es: '/footer',
    en: '/footer',
    fr: '/footer',
    uk: '/footer',
    it: '/footer',
    au: '/footer',
    us: '/footer',
    nl: '/footer'
  },
  [IRoutes.BLOGS_LANDING_PAGE]: {
    es: '/blog',
    en: '/blog',
    fr: '/blog',
    uk: '/blog',
    it: '/blog',
    au: '/blog',
    us: '/blog',
    nl: '/blog',
    de: '/blog'
  },
  [IRoutes.BLOGS]: {
    es: '/blog',
    en: '/blog',
    fr: '/blog',
    uk: '/blog',
    it: '/blog',
    au: '/blog',
    us: '/blog',
    nl: '/blog',
    de: '/blog'
  },
  [IRoutes.CUSTOM_PAGES]: {
    es: '/pagina',
    en: '/page',
    fr: '/page',
    uk: '/page',
    it: '/pagina',
    au: '/page',
    us: '/page',
    nl: '/pagina',
    de: '/seite'
  },
  [IRoutes.REORDER]: {
    es: '/my-account/label-library/reorder',
    en: '/my-account/label-library/reorder',
    fr: '/mon-compte/bibliotheque-etiquettes/reorder',
    uk: '/my-account/label-library/reorder',
    it: '/il-mio-account/libreria-delle-etichette/reorder',
    au: '/my-account/label-library/reorder',
    us: '/my-account/label-library/reorder',
    nl: '/mijn-account/labelbibliotheek/reorder',
    de: '/mein-konto/etikettenbibliothek/reorder'
  },
  [IRoutes.CUSTOM_FILES]: {
    es: '/mi-cuenta/biblioteca-de-etiquetas/custom-files',
    en: '/my-account/label-library/custom-files',
    fr: '/mon-compte/bibliotheque-etiquettes/custom-files',
    uk: '/my-account/label-library/custom-files',
    it: '/il-mio-account/libreria-delle-etichette/custom-files',
    au: '/my-account/label-library/custom-files',
    us: '/my-account/label-library/custom-files',
    nl: '/mijn-account/labelbibliotheek/custom-files',
    de: '/mein-konto/etikettenbibliothek/custom-files'
  },
  [IRoutes.SUCCESS_STORIES]: {
    es: '/historias-de-clientes',
    en: '/success-stories',
    fr: '/temoignages',
    uk: '/customer-stories',
    it: '/storie-di-successo',
    au: '/success-stories',
    nl: '/klantverhalen',
    us: '/success-stories',
    de: '/kundenstories'
  },
  [IRoutes.PRINT_FILE_ERRORS]: {
    es: '/print-file-error',
    en: '/print-file-error',
    fr: '/fichiers-non-conformes',
    uk: '/data-errors-in-your-print-files',
    it: '/errori-comuni-nei-file-di-stampa',
    au: '/print-file-error',
    us: '/print-file-error',
    nl: '/errors-in-druckbestanden',
    de: '/datenfehler'
  },
  [IRoutes.PRINT_FILE_ERRORS_FULL]: {
    es: '/print-file-error',
    en: '/print-file-error',
    fr: '/fichiers-non-conformes',
    uk: '/data-errors-in-your-print-files',
    it: '/errori-comuni-nei-file-di-stampa',
    au: '/print-file-error',
    us: '/print-file-error',
    nl: '/errors-in-druckbestanden',
    de: '/datenfehler'
  },
  [IRoutes.TUTORIAL]: {
    es: '/tutoriales',
    en: '/tutorials',
    it: '/tutorial',
    au: '/tutorials',
    us: '/tutorials',
    fr: '/tutoriels',
    uk: '/tutorials',
    nl: '/tutorials',
    de: '/tutorials'
  },
  [IRoutes.TUTORIAL_CMS]: {
    es: '/tutorial',
    en: '/tutorial',
    fr: '/tutorial',
    uk: '/tutorials',
    it: '/tutorial',
    au: '/tutorial',
    us: '/tutorial',
    nl: '/tutorial',
    de: '/tutorials'
  }
}
